var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download_btn_wrap",class:_vm.isSolid ? '' : 'solid_sty',on:{"click":_vm.handleDownload}},[_c('a-icon',{staticClass:"download_icon",attrs:{"theme":"filled","type":_vm.icon}}),_c('span',{staticClass:"btn_text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }